@if (message()) {
  <div
    class="shadow-lg fixed inset-x-4 bottom-20 z-50 mx-auto flex w-fit items-center rounded-lg bg-red-100 px-4 py-3 text-sm font-medium text-red-800 xl:bottom-4 xl:max-w-lg"
    role="alert"
  >
    <svg
      class="mr-2 h-5 w-5 text-red-500"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
        clip-rule="evenodd"
      ></path>
    </svg>
    {{ message() }}
  </div>
}
